var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssetAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.43 198.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29",
    x1: 100.43,
    y1: 123.89,
    x2: 162.88,
    y2: 123.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29",
    x1: 107.64,
    y1: 136.99,
    x2: 119.16,
    y2: 136.99,
    xlinkHref: "#SVGID_0_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29",
    x1: 144.35,
    y1: 136.99,
    x2: 155.87,
    y2: 136.99,
    xlinkHref: "#SVGID_0_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29",
    x1: 107.64,
    y1: 123.95,
    x2: 118.05,
    y2: 123.95,
    xlinkHref: "#SVGID_0_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29",
    x1: 144.9,
    y1: 123.95,
    x2: 155.32,
    y2: 123.95,
    xlinkHref: "#SVGID_0_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29",
    x1: 107.11,
    y1: 105.57,
    x2: 156.2,
    y2: 105.57,
    xlinkHref: "#SVGID_0_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29",
    x1: 75.99,
    y1: 22.38,
    x2: 86.54,
    y2: 22.38,
    xlinkHref: "#SVGID_0_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29",
    x1: 110.6,
    y1: 22.38,
    x2: 121.15,
    y2: 22.38,
    xlinkHref: "#SVGID_0_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29",
    x1: 38.52,
    y1: 116.76,
    x2: 91.53,
    y2: 116.76,
    xlinkHref: "#SVGID_0_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29",
    x1: 55.36,
    y1: 126.33,
    x2: 74.69,
    y2: 126.33,
    xlinkHref: "#SVGID_0_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29",
    x1: 25.93,
    y1: 82.27,
    x2: 104.82,
    y2: 82.27,
    xlinkHref: "#SVGID_0_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M101.68 130.68H90.97M122.64 30.75h11c2.31 0 4.19 2.08 4.19 4.64v61.26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M110.83 113.99h41.66c5.05 0 9.15 4.1 9.15 9.15v10.66h-59.96v-10.66c0-5.05 4.1-9.15 9.15-9.15z",
    stroke: "url(#SVGID_0_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_1_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29)",
    d: "M108.89 133.79h9.02v6.4h-9.02z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_2_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29)",
    d: "M145.6 133.79h9.02v6.4h-9.02z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_gradient",
    cx: 112.84,
    cy: 123.95,
    r: 3.96,
    stroke: "url(#SVGID_3_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_gradient",
    cx: 150.11,
    cy: 123.95,
    r: 3.96,
    stroke: "url(#SVGID_4_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_5_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29)",
    d: "M154.95 113.99h-46.59l6.69-16.83h33.21l6.69 16.83z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M59.61 68.79v-33.4c0-2.56 1.88-4.64 4.19-4.64h11.49"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M78.94 26.15s-5.02-7.53 2.23-7.53 2.51 7.53 2.51 7.53",
    stroke: "url(#SVGID_6_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M87.45 38.92H75.17l2-12h8.28l2 12z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M113.54 26.15s-5.02-7.53 2.23-7.53 2.51 7.53 2.51 7.53",
    stroke: "url(#SVGID_7_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M77.49 50.16h4.22v4.22h-4.22zM77.49 59.63h4.22v4.22h-4.22zM122.05 38.92h-12.28l2-12h8.28l2 12zM86.89 30.78h23.63M87.85 52.72h32.07M77.49 69.09h4.22v4.22h-4.22zM87.85 61.99h32.07M87.85 71.25h32.07"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_8_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29)",
    d: "M90.28 93.33v46.86H39.77V93.33"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_9_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29)",
    d: "M56.61 140.19v-27.71h16.83v27.71"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M65.38 65.45l36.6 27.57s3.25 2.37.46 5.19c-1.93 1.94-4.28.16-5.2-.53-8.34-6.25-32.31-23.79-32.31-23.79S41.86 91.43 33.52 97.68c-.93.69-3.27 2.47-5.2.53-2.8-2.82.46-5.19.46-5.19l36.6-27.57",
    stroke: "url(#SVGID_10_b26f6bd58dd57afa85835e09aab49ac80fb904cc31b31b0814be3ff188cb3c29)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetAnalysis);
export default __webpack_public_path__ + "static/media/assetAnalysis.36bb954a7fbc6bd7741277bf403e19bc.svg";
export { ForwardRef as ReactComponent };